<template>
  <button class="primary-button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "PrimaryButton",
};
</script>

<style scoped lang="scss">
$pageColor: #000;
.primary-button {
  width: 343px;
  height: 58px;
  font-size: 20px;
  color: $pageColor;
  border: solid 2px $pageColor;
  background-color: #fff;
  &:hover {
    cursor: pointer;
    color: #fff;
    border: solid 2px $pageColor;
    background-color: $pageColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/oauth/PrimaryButton.vue